import { render } from "./BaseAuthenticationPage.vue?vue&type=template&id=3efa18e5&scoped=true"
import script from "./BaseAuthenticationPage.vue?vue&type=script&lang=js"
export * from "./BaseAuthenticationPage.vue?vue&type=script&lang=js"

import "./BaseAuthenticationPage.vue?vue&type=style&index=0&id=3efa18e5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efa18e5"]])

export default __exports__